/**
 * Created By xiyuan
 * Author server@xiyuan.name (惜缘叛逆)
 * DateTime 2018/11/5 18:46
 * Describe 页面布局数据存储器
 * MIT License http://www.opensource.org/licenses/mit-license.php
 */
import Vuex from 'vuex'

import JSON from '@utils/json'

const headerConf = {
	left: {
		html: '',
		style: {},
		event: function () {
		
		}
	},
	center: {
		html: '',
		style: {},
		event: function () {
		
		}
	},
	right: {
		html: '',
		style: {},
		event: function () {
		
		}
	}
}

export default new Vuex.Store({
	state: {
		// 是否展示header
		showHeader: true,
		showFooter: true,
		showVisible: '0',
		headerInfo: JSON.parse(JSON.stringify(headerConf)),
		headerStyle: {}
	},
	getters: {},
	mutations: {
		// 设置header
		setHeader(state, {type, conf}) {
			Object.keys(conf).forEach(key => {
				state.headerInfo[type][key] = conf[key]
			})
		},
		// 重置header
		resetHeader(state) {
			state.headerInfo = JSON.parse(JSON.stringify(headerConf))
			state.headerStyle = {};
			state.showHeader = true;
			state.showFooter = true;
			state.showVisible = '0';
		}
	}
});
